import React, { FC } from 'react';
import { AccountStatisticsLayout } from './components/account-statistics-layout';
import {
  CardsSectionSkeleton,
  StatisticsGridSkeleton,
} from './components/skeletons';

export const AccountStatisticsLoading: FC = () => {
  return (
    <AccountStatisticsLayout>
      <StatisticsGridSkeleton />
      <CardsSectionSkeleton />
    </AccountStatisticsLayout>
  );
};
